import {Component} from 'react';
import FurnitureCard from './furniture_card';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';

class FurnitureInput extends Component {
  
    constructor(props) {
        super(props);
        props.onOpen();
        this.state = {
             loading: true,
             headers: setHeadersForFetch(),
             environment: Config.dataURL.currentEnv,
             subProcess: "FurnitureInput",
          
        }
        this.furnitureList = [];
        this.furnitureSelectId = "";
    
    }

    render() {
         let furnitureList = this.furnitureList.map((furnishings) =>
            <FurnitureCard selectedFurnitureId={this.furnitureSelectId} 
                key={furnishings.id} furnitureInfo={furnishings}        
            selected={() => this.onFurnitureSelected(furnishings)}/>
         );            
         return <>
            <div className="col-sm-8 mt-1">
                <div className="card mt-3 rounded-corners-lg text-center height-max">
                <h3 className="mt-2">Choose Furniture</h3>
                    {this.state.loading ?
                       <WaitTimeSpinner />                        

                    :
                        <div className="mt-2 mb-5 overflow-scroll">
                                {furnitureList}
                        </div>
                    }
                </div>
            </div>
            
        </>
    }

    componentDidMount(){
        this._isMounted = true;
        this.getFurnitureList();         
    }

    getFurnitureList() {
        const funcName = "furnitureList";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
            .then(response => { 
                if (response.ok){
                  response.json().then(data => {
                      const output = JSON.parse(data);
                      const statusCode = output.statusCode;
                      if (statusCode === 200){
                        this.furnitureList = output.body;
                        const selectedFurniture = sessionStorage.getItem("furnitureChoice");
                        if (selectedFurniture ) {
                            this.furnitureSelectId = selectedFurniture;
                        }
                        this.setState({loading: false});
                    }else{
                          const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                          this.props.processError(errorObj);
                      }
                  });
              };
        });      
     }

    onFurnitureSelected(furnishings) {
        sessionStorage.setItem("furnitureChoice", furnishings.id);
        sessionStorage.setItem("furnitureName", furnishings.title); 
        sessionStorage.setItem("furnitureCost", furnishings.cost);
        this.props.completed();
        this.props.onNavigate("choose-car");
    }

}

export default FurnitureInput;